import { render } from "./App.vue?vue&type=template&id=23dfef01&class=body&style='background-color'%3A%23000%20"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=23dfef01&lang=css"

import exportComponent from "/Users/robert.bryden/Documents/GitHub/nosecape-leaderboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__